export default __webpack_public_path__ + "static/media/upload-success.1129122d.svg";